import { render, staticRenderFns } from "./_ContactRow.vue?vue&type=template&id=29c7e0a7"
import script from "./_ContactRow.vue?vue&type=script&lang=js"
export * from "./_ContactRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports